import { Link } from 'react-router-dom';
import AuthShell from './AuthShell';

/**
 * Logged-out confirmation screen. Styles live in a scoped <style> block so
 * native `:hover` works without JS handlers.
 */
export default function LoggedOutPage(): JSX.Element {
  return (
    <AuthShell centered>
      <style>{LOGOUT_CSS}</style>
      <div className="auth-logout-title">You&apos;ve been logged out</div>
      <div className="auth-logout-message">Thank you for using Fulcrum&apos;s Research Portal</div>
      <Link to="/login" className="auth-login-again-btn">
        Login Again
      </Link>
    </AuthShell>
  );
}

/**
 * Scoped styles lifted verbatim from `templates/auth/logged_out.html`.
 * Hex kept as-is when no `--*` var maps; `#F9FAFB` uses `var(--light-bg)` in
 * AuthShell, `#FFFFFF` uses `var(--text-light)` in the logo panel.
 */
const LOGOUT_CSS = `
.auth-logout-title {
  color: #23272F;
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  text-align: center;
  letter-spacing: 0.01em;
}
.auth-logout-message {
  color: #4B5563;
  font-size: 0.98rem;
  font-weight: 400;
  margin: 0 0 1.5rem 0;
  text-align: center;
  letter-spacing: 0.01em;
}
.auth-login-again-btn {
  background: #4B5563;
  color: var(--text-light);
  padding: 0.7rem 2rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
  text-decoration: none;
  display: inline-block;
}
.auth-login-again-btn:hover {
  background: #374151;
  transform: translateY(-1px);
}
`;
